import { useContext } from 'react';
import { ErrorStatus, ErrorStatusContext } from 'shell/error/providers/error-provider';

/**
 * A custom hook to quickly read the context's value.
 * @returns {object} the object
 */
export const useErrorHandler = (): ErrorStatus => {
  return useContext(ErrorStatusContext);
};
